import * as React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/components/Dialog/";
import { PrimaryButton } from "@fluentui/react/lib/components/Button/PrimaryButton/PrimaryButton";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { Checkbox } from "@fluentui/react/lib/components/Checkbox/Checkbox";
import { Rating } from "@fluentui/react/lib/components/Rating";

class VerhinderungAppNutzungDialog extends React.Component {
    state = {
        isDialogHidden: true
    }

    componentDidMount() {
        console.log("start componentDidMount");
        const localStorageFlag: boolean = LocalCacheHelper.GetLocalStorageItemCpbxHideVerhinderungAppNutzungDialog();
        // console.log("localStorageFlag='" + localStorageFlag + "'");
        this.setState({
            isDialogHidden: localStorageFlag

        });
    }

    private onClickActionsButtonClose = (): void => {
        console.log("onClickActionsButtonClose");
        // not set for now (13th of may 2024) - Frank Spanknebel decided this (he wants to see the dialog each time)
        // LocalCacheHelper.SetLocalStorageItemCpbxHideVerhinderungAppNutzungDialogg(false);
        this.setState({
            isDialogHidden: true
        });
    };

    // hint: currently we do not provide any checkbox to let the user toggle
    // private onChangeDoNotSchow = (ev, val: boolean = false): void => {
    // console.log("onChangeDoNotSchow: ", val);
    // LocalCacheHelper.SetLocalStorageItemCpbxHideDecommissionDialog(val);
    // };

    render() {
        const dialogContentProps = {
            type: DialogType.normal,
            title: "Wichtige Hinweis:",
            subText: "Diese App steht nicht mehr zur Verfügung.",
            closeButtonAriaLabel: "Close",
            showCloseButton: true
        };

        return (
            <div>
                <Dialog
                    hidden={this.state.isDialogHidden}
                    dialogContentProps={dialogContentProps}
                    minWidth={600}
                    onDismiss={this.onClickActionsButtonClose}
                    className={"cpbxDialogContainer"}
                    modalProps={{ isBlocking: true }}
                >
                    <p className="cpbxDialogParagraph">
                        Selbstverständlich können Sie Ihre Cloud PBX weiterhin nutzen. Alle Funktionen von Cloud PBX stehen auch ohne App zur Verfügung.<br />Besuchen Sie für weitere Informationen unser:{" "}
                        <a
                            className="cpbxDialogMailto"
                            href="https://cpbx-hilfe.deutschland-lan.de/de/direkthilfe/arbeitsplatz-funktionen-und-dienste/funktionscodes"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Hilfeportal
                        </a>.{" "}<br />
                        Kontaktieren Sie uns gerne unter der Rufnummer{" "}
                        <a
                            className="cpbxDialogMailto"
                            href="tel:08003306708"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            0800 330 6708
                        </a>.{" "}
                        Um dien App aus Teams zu entfernen, klicken Sie erst links auf ... und öffnen dann mit der rechten Maustaste das Kontext-Menü der Cloud PBX App und wählen den Punkt Deinstallieren aus.

                    </p>

                    <DialogFooter>
                        <Rating />
                        <PrimaryButton
                            onClick={this.onClickActionsButtonClose}
                            text="Schließen"
                        />
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}
export default VerhinderungAppNutzungDialog;
